/*
 * Javascript that works with the salesforce liveagent snap-in.
 *
 * Author: Carlos Freund carlos@troy-bleiben.de
 */

/**
 * Prefills the Salesforce-LiveAgent prechat window with the currently logged in users data.
 *
 */
export function putUserDataIntoPrefill(customerData) {
  if (window.embedded_svc !== undefined) {
    window.embedded_svc.settings.prepopulatedPrechatFields = {
      FirstName: customerData.firstname,
      LastName: customerData.lastname,
      Email: customerData.main_email
    };
  }
}
